"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_1 = require("../../index");
const ColorPicker = (props) => {
    const { id, className, disabled, onBlur, onChange, errorMessage, value, } = props;
    return (React.createElement("div", { className: "color-picker-container" },
        React.createElement("fieldset", { className: classnames_1.default({
                'color-picker': true,
                'color-picker-disabled': disabled,
                [className]: !!className,
            }) },
            React.createElement(index_1.Input, { type: "text", id: id, value: value !== null && value !== void 0 ? value : '#ffffff', onChange: onChange, onBlur: onBlur, disabled: disabled !== null && disabled !== void 0 ? disabled : false }),
            React.createElement("input", { id: `${id}-color-picker`, type: "color", className: "color-picker-input", value: value !== null && value !== void 0 ? value : '#ffffff', onChange: onChange, onBlur: onBlur, disabled: disabled !== null && disabled !== void 0 ? disabled : false }),
            React.createElement(index_1.Label, { htmlFor: `${id}-color-picker`, className: "color-picker-box", style: { backgroundColor: value } })),
        errorMessage && (React.createElement(index_1.Message, { type: "error", message: errorMessage, form: true }))));
};
exports.default = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map